"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WATCHABLE_WEB_SOCKET_EVENTS = exports.SUPPORTABILITY_METRIC_CHANNEL = exports.SUPPORTABILITY_METRIC = exports.FEATURE_NAME = exports.CUSTOM_METRIC_CHANNEL = exports.CUSTOM_METRIC = void 0;
var _wrapWebsocket = require("../../common/wrap/wrap-websocket");
var _features = require("../../loaders/features/features");
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

const FEATURE_NAME = exports.FEATURE_NAME = _features.FEATURE_NAMES.metrics;
const SUPPORTABILITY_METRIC = exports.SUPPORTABILITY_METRIC = 'sm';
const CUSTOM_METRIC = exports.CUSTOM_METRIC = 'cm';
const SUPPORTABILITY_METRIC_CHANNEL = exports.SUPPORTABILITY_METRIC_CHANNEL = 'storeSupportabilityMetrics';
const CUSTOM_METRIC_CHANNEL = exports.CUSTOM_METRIC_CHANNEL = 'storeEventMetrics';
const WATCHABLE_WEB_SOCKET_EVENTS = exports.WATCHABLE_WEB_SOCKET_EVENTS = ['new', 'send', 'close', _wrapWebsocket.ADD_EVENT_LISTENER_TAG];